import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  ButtonGroup,
  Button,
} from "@mui/material";
import { useVendor } from "../../utils/Context";
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import dayjs from "dayjs";
import Cards from "../Cards/Cards";
import ChartSecond from "../Chart/ChartSecond";
import Loading from "../Loading";
import FilterDrawer from "./FilterDrawer";
import { getPermissionByPrefix } from "../../utils/permissions";
import { useErrorToast } from "../../hooks/useErrorToast";
import { useQuery } from '@tanstack/react-query';

import DashboardSummaryCards from "./DashboardSummaryCards";
import { CiFilter } from "react-icons/ci";
import { IoIosRefresh } from "react-icons/io";
import { IconButton } from "@mui/material";
import FinanceDashboard from "./FinanceDashboard";




export const fetchDashboard = async ({ queryKey }) => {
  const [_, { startDate, endDate, selectedVendor, selectedLoc, selectedCountry }] = queryKey;
  const token = localStorage.getItem("tokenInv");

  let url = `${process.env.REACT_APP_URL}/api/dashboard-overview?start_date=${startDate}&end_date=${endDate}`;
  if (selectedVendor !== -1) url += `&vendor_id=${selectedVendor}`;
  if (selectedLoc !== "All") url += `&location_id=${selectedLoc}`;
  if (selectedCountry !== "All") url += `&country=${selectedCountry.toLowerCase()}`;

  const response = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });

  response.data["remaining_discrepancy"] = response?.data?.total_discrepancy - response?.data?.total_settled;
  return response.data;
};



const fetchLocations = async ({ queryKey }) => {
  const [_, selectedVendor] = queryKey;
  const token = localStorage.getItem("tokenInv");

  let url = `${process.env.REACT_APP_URL}/get-locations?is_discrepancy=false`;
  if (selectedVendor !== -1) {
    url += `&vendor_id=${selectedVendor}`;
  }

  const response = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });

  return response.data.data;
};

const Dashboard = () => {
    const showError = useErrorToast();

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [vendor, setVendor] = useState({});
  const { vendors, selectedVendor } = useVendor();
  const [filterModal, setFilterModal] = useState(false);
  const [dateRange, setDateRange] = useState({
  start: dayjs("2025-11-01"),
  end: dayjs(),
});
  const [activeDatePreset, setActiveDatePreset] = useState("current_fy");

  const handleDatePreset = (preset) => {
    setActiveDatePreset(preset);
    if (preset === "current_fy") {
      setDateRange({
        start: dayjs("2025-11-01"),
        end: dayjs()
      });
    } else if (preset === "last_fy") {
      setDateRange({
        start: dayjs("2024-11-01"),
        end: dayjs("2025-10-31")
      });
    } else if (preset === "all") {
      setDateRange({
        start: dayjs("2024-01-01"),
        end: dayjs()
      });
    }
  };
  const [locations, setLocations] = useState([]);
  const [selectedLoc, setSelectedLoc] = useState("All");
  const [country, setCountry] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("All");
  const [filterLocation,setFilterLocation] = useState(["All"])
const [isInitialLoad, setIsInitialLoad] = useState(true);
const [isRefreshing, setIsRefreshing] = useState(false);

  const {
  is_view: canViewDashboard,
  is_add: canAddDashboard,
  is_edit: canEditDashboard,
  is_delete: canDeleteDashboard,
} = getPermissionByPrefix("dashboard_overview");

const {
  is_view: canViewCredit,
  is_add: canAddCredit,
  is_edit: canEditCredit,
  is_delete: canDeleteCredit,
} = getPermissionByPrefix("credit_achievement");

const { is_view: canViewLocation } = getPermissionByPrefix("manage_location");

const {
  data: locationData,
  isLoading: loadingLocations,
  isError: locationError,
  error: locationErrorObj,
  refetch: refetchLocations
} = useQuery({
  queryKey: ["locations", selectedVendor],
  queryFn: fetchLocations,
  enabled: canViewLocation,
  staleTime: 15 * 60 * 1000,
  retry: false,
  onError: (error) => {
    if (error.response?.status === 401) {
      showError("Session Expired! Please Login");
      localStorage.removeItem("tokenInv");
      localStorage.removeItem("roleInv");
      navigate("/");
    } else {
      showError(error?.response?.data?.message || "Failed to load locations");
    }
  },
});

useEffect(() => {
  if (locationData) {
    setLocations(locationData);

    let countries = locationData.map((el) => el?.updated_country || el?.country || "N/A");
    countries = Array.from(new Set(countries)).sort((a, b) => a.localeCompare(b));
    countries.unshift("All");
    setCountry(countries);
  }
}, [locationData]);

  useEffect(() => {
    setVendor(vendors.find((el) => el.id === selectedVendor) || {});
  }, [selectedVendor, vendors]);

const stableQueryKey = [
  "dashboard",
  {
    startDate: dateRange.start.format("YYYY-MM-DD"),
    endDate: dateRange.end.format("YYYY-MM-DD"),
    selectedVendor,
    selectedLoc,
    selectedCountry,
  },
];


const {
  data: dashboard,
  isLoading: loadingDashboard,
  isError,
  error,
  refetch,
} = useQuery({
  queryKey: stableQueryKey,
  queryFn: fetchDashboard,
  enabled: canViewDashboard,
  retry: false,
  staleTime: 10 * 60 * 1000,
  gcTime: 30 * 60 * 1000, 
    onSuccess: () => {
    setFilterModal(false);
        setIsInitialLoad(false);
  },
  onError: (error) => {
    if (error.response?.status === 401) {
      showError("Session Expired! Please Login");
      localStorage.removeItem("tokenInv");
      navigate("/");
    } else {
      showError(error?.response?.data?.message || "Something went wrong. Please try again.");
    }
  },
});
// console.log("dashboard",dashboard)
  // const formatNumber = (num) => {
  //   if (num >= 1_000_000) {
  //     return (num / 1_000_000).toFixed(2).replace(/\.?0+$/, "") + "M";
  //   } else if (num >= 1_000) {
  //     return (num / 1_000).toFixed(2).replace(/\.?0+$/, "") + "K";
  //   }
  //   return num.toFixed(2);
  // };

  const formatNumber = (num) => {
  const value = Number(num);

  if (!Number.isFinite(value)) {
    return "0.00";
  }

  const absValue = Math.abs(value);

  if (absValue >= 1_000_000) {
    return (value / 1_000_000).toFixed(2).replace(/\.?0+$/, "") + "M";
  }

  if (absValue >= 1_000) {
    return (value / 1_000).toFixed(2).replace(/\.?0+$/, "") + "K";
  }

  return value.toFixed(2);
};


  const [isReloading, setIsReloading] = useState(false);


  const reloadDashboard = async () => {
  try {
        setIsRefreshing(true);

    const token = localStorage.getItem("tokenInv");
    const url = `${process.env.REACT_APP_URL}/api/calc_and_save_discrepancy`;

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    });
    await refetch();
    // queryClient.invalidateQueries(['locations']);
    // console.log("Dashboard reloaded successfully:", response.data);
  } catch (error) {
    console.error("Error reloading dashboard:", error);
  } finally {
    setIsRefreshing(false);
  }
};



const handleCloseFilter = () => {
  setFilterModal(false);
}
  return (
    <Box sx={{ p: 2, bgcolor: "#f9f9f9", minHeight: "100vh" }}>
      <FilterDrawer
        filterModal={filterModal}
        setFilterModal={setFilterModal}
        dateRange={dateRange}
        setDateRange={setDateRange}
        country={country}
        setCountry={setCountry}
        selectedCountry={selectedCountry}
        setSelectedCountry={setSelectedCountry}
        onFilter={refetch}
        locations={locations}
        setLocations={setLocations}
        selectedLoc={selectedLoc}
        setSelectedLoc={setSelectedLoc}
        filterLocation={filterLocation}
        setFilterLocation={setFilterLocation}
        canViewLocation={canViewLocation}
        canViewDashboard={canViewDashboard}
        handleCloseFilter={handleCloseFilter}
      />
      <Toaster position="top-right" reverseOrder={false} />

      <Box sx={{ position: "relative" }}>
        <Box
          component="header"
        sx={{
          position: "sticky",
          top: "80px",
          zIndex: 1000,
          px: 2,
          py: 1,
          mb: 2,
          display: "flex",
          alignItems: "center",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          justifyContent: "space-between",
          borderBottom: "1px solid #e5eaf0",
          backgroundColor: "#fff",
          borderRadius: "10px",
        }}
      >
        {/* Left: Title */}
        <Typography
          variant="h6"
          fontWeight={600}
          color="primary"
          textAlign="center"
        >
          {vendor?.name || "Vendor Name"}
        </Typography>

        {/* Right: Actions */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          
          {/* Quick Date Filters */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 2, borderRight: '1px solid #e0e0e0', paddingRight: '16px' }}>
            <Box sx={{ display: "flex", gap: '4px', backgroundColor: '#f0f0f0', padding: '4px', borderRadius: '8px' }}>
              <Button 
                onClick={() => handleDatePreset('current_fy')} 
                variant={activeDatePreset === 'current_fy' ? 'contained' : 'text'}
                size="small"
                disableElevation
                sx={{ borderRadius: '6px', textTransform: 'none', minWidth: '90px', padding: '4px 16px', fontWeight: 600, color: activeDatePreset === 'current_fy' ? '#fff' : 'text.secondary' }}
              >Current FY</Button>
              <Button 
                onClick={() => handleDatePreset('last_fy')} 
                variant={activeDatePreset === 'last_fy' ? 'contained' : 'text'}
                size="small"
                disableElevation
                sx={{ borderRadius: '6px', textTransform: 'none', minWidth: '90px', padding: '4px 16px', fontWeight: 600, color: activeDatePreset === 'last_fy' ? '#fff' : 'text.secondary' }}
              >Last FY</Button>
              <Button 
                onClick={() => handleDatePreset('all')} 
                variant={activeDatePreset === 'all' ? 'contained' : 'text'}
                size="small"
                disableElevation
                sx={{ borderRadius: '6px', textTransform: 'none', minWidth: '90px', padding: '4px 16px', fontWeight: 600, color: activeDatePreset === 'all' ? '#fff' : 'text.secondary' }}
              >All</Button>
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
              {dateRange.start ? dateRange.start.format('MM/DD/YYYY') : ''} - {dateRange.end ? dateRange.end.format('MM/DD/YYYY') : ''}
            </Typography>
          </Box>

          {canViewDashboard && (<>
          <IconButton
  size="small"
  title="Refresh"
  color="primary"
  onClick={reloadDashboard}
  disabled={isRefreshing}
>
  <IoIosRefresh
    size={18}
    style={{
      animation: isRefreshing ? "spin 1s linear infinite" : "none",
    }}
  />
</IconButton>

{isRefreshing && (
  <Typography variant="caption" color="text.secondary">
    Refreshing…
  </Typography>
)}
</>
            // <IconButton
            //   size="small"
            //   title="Refresh"
            //   color="primary"
            //   onClick={reloadDashboard}
            // >
            //   <IoIosRefresh size={18} />
            // </IconButton>
          )}

          {(canViewDashboard || canViewLocation) && (
            <IconButton
              size="small"
              title="Filters"
              color="primary"
              onClick={() => setFilterModal(true)}
            >
              <CiFilter size={18} />
            </IconButton>
          )}
        </Box>
      </Box>

      {/* {loading ? <Loading /> : <></>}
      {loadingDashboard ? <Loading /> : <></>} */}
{isInitialLoad && loadingDashboard && <Loading />}

      {canViewDashboard && (
        <>
          <FinanceDashboard
            dashboardData={dashboard}
            formatNumber={formatNumber}
            dateRange={dateRange}
            setDateRange={setDateRange}
            activeDatePreset={activeDatePreset}
            selectedVendor={selectedVendor}
            selectedLoc={selectedLoc}
            setSelectedLoc={setSelectedLoc}
            country={country}
            setSelectedCountry={setSelectedCountry}
            selectedCountry={selectedCountry}
            locations={locations}
            setFilterLocation={setFilterLocation}
            filterLocation={filterLocation}
            canViewLocation={canViewLocation}
            refetch={refetch}
          />
        </>
      )}
      </Box>

      {/* Bottom Section: Discrepancy by Country */}
      <div style={{ marginTop: '20px', marginBottom: '16px', height: '400px' }}>
        {canViewDashboard && <ChartSecond servicesData={dashboard || {}} />}
      </div>
    </Box>
  );
};

export default Dashboard;
